import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-loggedout',
    templateUrl: './loggedout.component.html',
    styleUrl: './loggedout.component.css'
})
export class LoggedoutComponent {

constructor(private readonly router: Router) {}
  login() {
    this.router.navigate(['login']);
  }
}
